import React, { useRef, useState } from 'react';

import SearchWithAddColor from '@components/colors/SearchWithAddColor';

import { validateNumber } from '@utils/Util';

const SampleColorPopUp = ({
	colorList = [],
	selectedDesignId,
	item,
	onCancel,
	onChangeColorItem,
	onClickAddNewItem,
	onClickColorSubmit,
	errors,
	isShowAddColor = true
}) => {
	const [editColorId, setEditColorId] = useState(null);
	const popUpRef = useRef({});

	const onEditClick = (id) => {
		setEditColorId(id);
	};

	const onAddNewColor = (item) => {
		onClickAddNewItem(item, editColorId);
	};

	const onGetSizeError = (item) => {
		return errors?.some((err) => err.errorKey === item.key && err?.type === 'SIZE');
	};

	const onGetQuantityError = (item) => {
		return errors?.some((err) => err.errorKey === item.key && err?.type === 'QUANTITY');
	};

	const onGetColorError = (item) => {
		return errors?.some((err) => err.errorKey === item.key && err?.type === 'COLOR');
	};

	const safeColorList = Array.isArray(colorList) ? colorList : [];

	return (
		<>
			<div className="sample-details" key={selectedDesignId} ref={popUpRef}>
				{safeColorList.filter((color) => (color.size && color.quantity) || color.code || color.name)
					.length === 0 && <p>Add size, qty & color</p>}
				{safeColorList.map(
					(color) =>
						(color.size || color.quantity || color.code || color.name) && (
							<ul
								className="common-list-component align-items-center mb-2"
								key={`${color.key}`}
							>
								<li className="d-flex align-items-center">
									{color.hexCode && (
										<span className="color-icon" style={{ background: color.hexCode }} />
									)}
									<span className="ml-1">{color.code || color.name}</span>
								</li>

								<li>
									{(color?.size || color.quantity) && (
										<span>
											{color?.size} {color?.size && '-'} {color?.quantity} PCS
										</span>
									)}
								</li>
							</ul>
						)
				)}
			</div>

			{isShowAddColor && selectedDesignId === item.id && (
				<div className="sample-details-popup">
					<table className="add-sample-details-table">
						<tbody>
							{safeColorList.map((color) => (
								<>
									<tr key={`${color.key}`}>
										<td>
											{color.hexCode && (
												<span
													className="color-icon"
													style={{ background: color.hexCode }}
												/>
											)}
											<img
												src={`${process.env.PUBLIC_URL}/icons/add_primary.svg`}
												alt="add"
												onClick={() => onEditClick(`${color.key}`)}
											/>
										</td>
										<td>
											<input
												className={`${
													onGetColorError(color) && 'common-border-error'
												}`}
												type="text"
												autoComplete="off"
												placeholder="Color"
												value={color.code}
												name="code"
												onChange={(e) => onChangeColorItem(e, color, item)}
											/>
										</td>
										<td>
											<input
												className={`${
													onGetSizeError(color) && 'common-border-error'
												}`}
												type="text"
												autoComplete="off"
												placeholder="Size"
												name="size"
												value={color.size || ''}
												onChange={(e) => onChangeColorItem(e, color, item)}
											/>
										</td>
										<td>
											<input
												className={`${
													onGetQuantityError(color) && 'common-border-error'
												}`}
												type="number"
												placeholder="Qty*"
												name="quantity"
												value={color.quantity || ''}
												onChange={(e) => onChangeColorItem(e, color, item)}
												onKeyPress={validateNumber}
												min="1"
												max="4"
											/>
										</td>
									</tr>
									{editColorId === `${color.key}` && (
										<SearchWithAddColor
											onEditClick={() => setEditColorId(null)}
											selectedColorList={colorList}
											onAddNewColor={onAddNewColor}
										/>
									)}
								</>
							))}
						</tbody>
					</table>
					<div className="action-buttons text-right">
						<button className="button text size32" onClick={onCancel}>
							<span className="gray_dark_02">Cancel</span>
						</button>
						<button className="button text ml-2" onClick={onClickColorSubmit}>
							Submit
						</button>
					</div>
				</div>
			)}
		</>
	);
};

export default SampleColorPopUp;
